import { Rating } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useKey } from 'react-use';
import { d, numeric } from 'shared-base';
import Button from '../Button/Button';
import IconButton from '../IconButton/IconButton';
import { Actions, Image, Keys, Prompt, Top, Wrapper } from './QualityDetails.style';

export type QualityDetailsProps = {
  item: IQuality;
  index: number;
  total: number;
  onNext: () => void;
  onPrev: () => void;
  onRate: (rating: number) => void;
};

export function QualityDetails(props: QualityDetailsProps) {
  const { index, item, total } = props;
  const [value, setValue] = useState(item?.stars || 0);

  useEffect(() => {
    setValue(item?.stars || 0);
  }, [item]);

  function onSubmit() {
    if (value === 0) return;
    props.onRate(value);
  }

  useKey('1', () => setValue(1));
  useKey('2', () => setValue(2));
  useKey('3', () => setValue(3));
  useKey('4', () => setValue(4));
  useKey('5', () => setValue(5));

  useKey(
    'Enter',
    () => {
      onSubmit();
    },
    {
      event: 'keydown',
    },
    [value]
  );

  return (
    <Wrapper className='QualityDetails-wrapper' data-testid='QualityDetails-wrapper'>
      <Top>
        <div>{item.id} </div>
        <div>
          {numeric(index + 1)}/{numeric(total)}
        </div>
        <div>
          {d.db(item.createdAt)} - {d.timeShort(item.createdAt)}
        </div>
        <div className={item.service}>
          <span>{item.service}</span>
        </div>
        {item.isSubscriber && <div className='gold'>SUBSCRIBER</div>}
      </Top>
      <Image>
        <Prompt>{item.prompt}</Prompt>
      </Image>
      <Actions>
        <div>
          <IconButton size={30} name='IconArrowLeft' color='#fff' onClick={props.onPrev} />
          <IconButton size={30} name='IconArrowRight' color='#fff' onClick={props.onNext} />
        </div>
        <div>
          <Rating value={value} onChange={setValue} size='xl' />
          <Keys>use keys (1-5)</Keys>
        </div>
        <Button color='pink' onClick={onSubmit}>
          Save Rating ↵
        </Button>
      </Actions>
    </Wrapper>
  );
}

export default QualityDetails;
